import cn from 'classnames';
import { Label } from '@creditflowresearch/uilib/Badge/Label';
import styles from './countLabel.module.scss';

interface IProps {
  /**
   * The maximum count value that can be displayed.
   */
  maxTotalCount?: number,
  /**
   * The font size of the text. Default is 10.
   */
  fontSize?: number,
  /**
   * The background color of the component.
   */
  backgroundColor: string,
  /**
   * Determines whether the count should be displayed.
   */
  canShowCount: boolean,
  /**
   * Determines if the count should be shown when the value is zero.
   */
  showCountWithZeroVolume?: boolean,
  /**
   * Sets the skeleton-animation.
   */
  isFetching?: boolean,
  /**
   * Sets the text to bold.
   */
  isBold?: boolean,
  /**
   * The numeric value to be displayed.
   */
  totalCount: number,
  /**
   * Additional CSS class for custom styling.
   */
  className?: string,
}

const CountLabel = (
  {
    totalCount,
    canShowCount,
    showCountWithZeroVolume = true,
    maxTotalCount = Infinity,
    className,
    backgroundColor,
    fontSize = 10,
    isBold = true,
    isFetching = false,
  }: IProps,
) => {
  if (canShowCount) {
    if (totalCount === 0 && !showCountWithZeroVolume) {
      return <></>;
    }

    return (
      <Label
        className={ cn(styles.countInTab, className, {
          [styles.animatedPreloader]: isFetching,
        }) }
        backgroundColor={ backgroundColor }
        fontSize={ fontSize }
        isBold={ isBold }
      >
        { totalCount > maxTotalCount ? `${ maxTotalCount }+` : totalCount }
      </Label>
    );
  }
  return <></>;
};

export default CountLabel;
